module.exports = __webpack_public_path__ + "static/media/app-screenshot-1.fd19873a.webp";